import { TableColumn } from "../pages/ListReceipt";

export const columns: TableColumn[] = [
  { key: "redeem", header: "Redeem", isCheckbox: true },
  { key: "image", header: "Image" },
  { key: "amount", header: "Uploaded Amount $" },
  {
    key: "calculated_receipt_amount",
    header: "Updated Amount $",
  },
  { key: "merchant", header: "Merchant" },
  { key: "merchant_type", header: "Merchant Category" },
  { key: "status", header: "Status" },
  { key: "receipt_number", header: "Receipt Number" },
  { key: "submission_date", header: "Submitted Date" },
  { key: "review_date", header: "Reviewed Date" },
  { key: "points_awarded", header: "Points Awarded" },
  { key: "payment_type", header: "Payment Type" },
  { key: "partner", header: "Partner" },

  { key: "birthday_points", header: "Birthday Points" },
];
export const csColumns: TableColumn[] = [
  { key: "redeem", header: "Select", isCheckbox: true },
  { key: "image", header: "Image" },
  { key: "receipt_number", header: "Receipt No" },
  { key: "receiptDateTime", header: "Receipt Date & Time" },
  { key: "merchant", header: "Merchant" },
  { key: "receiptAmount", header: "Receipt Amount" },
  { key: "points_awarded", header: "Points Awarded" },
  { key: "submission_date", header: "Submitted Date & Time" },
  { key: "status", header: "Status" },
  { key: "partner", header: "Partner" },
];

export const metaData = {
  image: {
    isImage: true,
    linkTo: "",
  },
  amount: {
    isImage: false,
    linkTo: "",
  },
  calculated_receipt_amount: {
    isImage: false,
    linkTo: "",
  },
  merchant: {
    isImage: false,
    linkTo: "",
  },
  merchant_type: {
    isImage: false,
    linkTo: "",
  },
  receipt_number: {
    isImage: false,
    linkTo: "",
  },
  submission_date: {
    isImage: false,
    linkTo: "",
  },
  status: {
    isImage: false,
    linkTo: "",
  },
  review_date: {
    isImage: false,
    linkTo: "",
  },
  points_awarded: {
    isImage: false,
    linkTo: "",
  },
  birthday_points: {
    isImage: false,
    linkTo: "",
  },
  partner: {
    isImage: false,
    linkTo: "",
  },

  redeem: {
    isImage: false,
    linkTo: "",
  },
};
